import { AccordionCard } from 'components/AccordionCard/AccordionCard'
import { Button, Message, useAppTheme } from '@workwhile/ui'
import React from 'react'
import { useDayforcePanelContextValue } from '../context/DayforcePanelProvider'
import { InfoTable } from 'components/InfoTable/InfoTable'
import { DayforceJobDetailsModal } from './DayforceJobDetailsModal'
import {
  DayforceJobBooking,
  DayforceJobDetail,
} from 'api/admin/dayforce/getDayforceJob'
import { useShiftDetailContextValue } from 'pages/Shifts/ShiftDetail/context/ShiftDetailProvider'

const BookingDetails = ({
  booking,
  job,
}: {
  booking: DayforceJobBooking
  job: DayforceJobDetail
}) => {
  const { space } = useAppTheme()
  const {
    state: { isDayforceJobDetailsModalOpen },
    actions: { toggleDayforceJobDetailsModal },
  } = useDayforcePanelContextValue()

  const noWorkersRequired = booking.workersRequired === 0

  return (
    <>
      {noWorkersRequired ? (
        <Message variant="warning" borderRadius="small">
          No workers required for this booking. This is likely a canceled job in
          Dayforce.
        </Message>
      ) : null}
      <InfoTable
        style={{
          width: 'auto',
          borderSpacing: `0 ${space[2]}`,
          marginTop: `-${space[2]}`,
          marginBottom: `-${space[2]}`,
        }}
      >
        <InfoTable.Row label="Job ID" value={job.jobId || ''} />
        <InfoTable.Row label="Job Status" value={job.jobStatus || ''} />
        <InfoTable.Row label="Booking ID" value={booking.bookingId} />
        <InfoTable.Row
          label="Hazmat Old Booking ID"
          value={booking.hazmatOldBookingId || ''}
        />
        <InfoTable.Row label="Job Name" value={booking.jobName || ''} />
        <InfoTable.Row label="Position Name" value={booking.position.name} />
        <InfoTable.Row
          label="Workers Assigned"
          value={booking.workersAssigned}
        />
        <InfoTable.Row
          label="Workers Required"
          value={booking.workersRequired}
        />
        <InfoTable.Row
          label="Backup Workers Assigned"
          value={booking.backupWorkersAssigned}
        />
        <InfoTable.Row
          label="Backup Workers Required"
          value={booking.backupWorkersRequired}
        />
        <InfoTable.Row label="Bonus" value={booking.bonus} />
        <InfoTable.Row label="Travel Stipend" value={booking.travelStipend} />
      </InfoTable>
      <Button
        variant="text"
        kind="text"
        onClick={toggleDayforceJobDetailsModal}
        size="small"
      >
        View Dayforce Job Details
      </Button>
      {isDayforceJobDetailsModalOpen ? (
        <DayforceJobDetailsModal onClose={toggleDayforceJobDetailsModal} />
      ) : null}
    </>
  )
}

export const DayforcePanelMain = () => {
  const { space } = useAppTheme()

  const {
    state: { dayforceJobId, dayforceBookingId },
  } = useShiftDetailContextValue()

  const {
    state: { booking, job },
  } = useDayforcePanelContextValue()

  return (
    <AccordionCard
      title="Dayforce Booking Details"
      size="fit"
      contentWrapperProps={{
        display: 'flex',
        flexDirection: 'column',
        width: '376px',
      }}
    >
      <InfoTable
        style={{
          width: 'auto',
          borderSpacing: `0 ${space[2]}`,
          marginTop: `-${space[2]}`,
          marginBottom: `-${space[2]}`,
        }}
      >
        <InfoTable.Row label="Job ID" value={dayforceJobId || ''} />
        <InfoTable.Row label="Booking ID" value={dayforceBookingId || ''} />
      </InfoTable>
      {!job ? (
        <Message variant="error" borderRadius="small">
          Error loading Dayforce job details
        </Message>
      ) : null}
      {!booking ? (
        <Message variant="error" borderRadius="small">
          Error loading Dayforce booking details
        </Message>
      ) : null}
      {job && booking ? <BookingDetails booking={booking} job={job} /> : null}
    </AccordionCard>
  )
}
